import { createPartialRoute } from "./PartialRouteDefinition";
import { routeTemplate, spaceIdPlaceholder } from "./RouteTemplate";
// Most pages are either scoped to a space ("space-scoped") or not ("system-scoped").
// For pages that aren't scoped to a space, we still have a space selected in the space switcher,
// and we still have a space id present in the route.
// However, we don't expose that spaceId to individual pages, which also means we reserve the right to remove it from the route in future.
// N.B. The spaceID placeholder is optional, which means it includes the leading `/`. If it isn't provided, then we don't want an extra `/`.
export const systemPartialRoute = createPartialRoute(routeTemplate `${spaceIdPlaceholder}`);
